import { render, staticRenderFns } from "./SingleEvent.vue?vue&type=template&id=372b6bd6&scoped=true"
import script from "./SingleEvent.vue?vue&type=script&lang=js"
export * from "./SingleEvent.vue?vue&type=script&lang=js"
import style0 from "./SingleEvent.vue?vue&type=style&index=0&id=372b6bd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372b6bd6",
  null
  
)

export default component.exports